<template>
	<footer class="footer__container">
		<div id="footerwrapper" class="footer">
			<b-container fluid>
				<b-row>
					<b-col class="footer__address col-12 col-sm-4">
						<address>
							<p class="mb-1">
								<a
									:aria-label="'tel:' + $t('footerTelefonnummerLong')"
									:href="'tel:' + $t('footerTelefonnummerHref')"
									><span class="bold" aria-hidden="true">{{
										$t("footerTelefonnummer")
									}}</span></a
								>
							</p>
							<p class="mb-1">Bolagsverket</p>
							<p class="mb-1">{{ $t("footerPostnrOrt") }}</p>
						</address>
					</b-col>
					<b-col class="footer__links col-12 col-sm-4">
						<p class="mb-1">
							<a
								target="_blank"
								:title="$t('footerKontaktaOss') + ', ' + $t('footerNewWindow')"
								class="link__external"
								rel="noopener"
								:href="$t('kontaktaOssUrl')"
								>{{ $t("footerKontaktaOss") }}</a
							>
						</p>
						<p class="mb-1">
							<a
								target="_blank"
								:title="
									$t('footerTillganglighet') + ', ' + $t('footerNewWindow')
								"
								rel="noopener"
								class="link__external"
								:href="$t('tillganglighetUrl')"
								>{{ $t("footerTillganglighet") }}</a
							>
						</p>
						<p class="mb-1">
							<a
								target="_blank"
								:title="
									$t('footerPersonuppgifter') + ', ' + $t('footerNewWindow')
								"
								rel="noopener"
								class="link__external"
								:href="$t('personuppgifterUrl')"
								>{{ $t("footerPersonuppgifter") }}</a
							>
						</p>
					</b-col>
					<b-col class="pl-sm-0 col-12 col-sm-4 align-self-sm-end text-sm-right">
						<img
							class="logo mb-3"
							src="@/assets/images/logo-bw.svg"
							alt="Logotyp Bolagsverket"
						/>
					</b-col>
				</b-row>
			</b-container>
		</div>
	</footer>
</template>

<script></script>

<style scoped>
    .footer__container {
        width: 100%;
        background-color: #002857;
        color: #fff;
        display: block;
    }
.footer {
	position: relative;
	padding: 1.5em 0;
}
.footer__address a:link span {
	text-decoration: underline;
}

.footer span {
	display: block;
	white-space: nowrap;
}

.footer a:link,
.footer a:visited {
	color: #fff;
	text-decoration: none;
}
.footer a:hover {
	text-decoration: underline;
}

.footer a:active {
	outline-color: transparent;
	outline: 0;
}

.footer a:focus {
	outline-color: #fecb00;
}

.footer address a {
	font-weight: bold;
}

.link__external {
	padding-right: 20px;
	background-image: url("../assets/images/external-link-inv.png");
	background-repeat: no-repeat;
	background-position: 100% 50%;
}
.logo {
	display: inline-block;
	margin-bottom: -0.3rem;
	height: 2rem;
}

</style>
